import { useState, useMemo, useCallback, useEffect, useRef } from 'react';
export function useElementFitsContainer<C extends HTMLElement = HTMLElement, T extends HTMLElement = HTMLElement>(fallbackWidth: number = 100) {
  const container = useRef<C>(null);
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(ref.current?.clientWidth ?? fallbackWidth);
  const [windowWidth, setWindowWidth] = useState(container?.current?.clientWidth ?? fallbackWidth + 100);
  const safeWindow = useMemo(() => typeof window !== 'undefined' ? window : null, []);
  const offset = container.current?.offsetLeft ?? 16;
  const fitsContainer = windowWidth > 640 || width < windowWidth - offset * 2;
  const handleResize = useCallback(() => {
    if (ref.current !== null) {
      setWidth(ref.current.clientWidth);
    }
    setWindowWidth(safeWindow?.innerWidth ?? 0);
  }, []);
  useEffect(() => {
    handleResize();
    safeWindow?.addEventListener('resize', handleResize);
    return () => {
      safeWindow?.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  return [container, ref, fitsContainer] as const;
}